import { render, staticRenderFns } from "./LamboDigitalChecksColumn.vue?vue&type=template&id=4b3773ad&scoped=true&"
import script from "./LamboDigitalChecksColumn.vue?vue&type=script&lang=js&"
export * from "./LamboDigitalChecksColumn.vue?vue&type=script&lang=js&"
import style0 from "./LamboDigitalChecksColumn.vue?vue&type=style&index=0&id=4b3773ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3773ad",
  null
  
)

export default component.exports